import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Pill, Sparkles, HeartPulse, FlaskConical, Stethoscope, Activity } from "lucide-react";
import api from "@/lib/api";

const ICONS = {
  "Prescription Rx": Pill,
  "Supplements": Sparkles,
  "Cardiac Care": HeartPulse,
  "Syrups & Tonics": FlaskConical,
  "Medical Devices": Stethoscope,
  "OTC Health": Activity,
};

export default function CategoryCircles() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/products/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  if (categories.length === 0) return null;

  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-8 pt-28 pb-2" data-testid="category-circles-row">
      <div className="flex gap-5 overflow-x-auto no-scrollbar pb-3 justify-start lg:justify-center">
        {categories.map((cat, i) => {
          const Icon = ICONS[cat] || Activity;
          return (
            <motion.button
              key={cat}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.06, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              onClick={() => navigate(`/shop?category=${encodeURIComponent(cat)}`)}
              data-testid={`category-circle-${cat.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="flex flex-col items-center gap-2.5 shrink-0 group"
            >
              <span className="w-20 h-20 rounded-full bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-800 transition-all duration-300 group-hover:scale-110 group-hover:bg-emerald-700 group-hover:text-white group-hover:shadow-lg">
                <Icon size={30} strokeWidth={1.6} />
              </span>
              <span className="text-xs font-semibold text-slate-700 text-center max-w-[92px] leading-tight">{cat}</span>
            </motion.button>
          );
        })}
      </div>
    </section>
  );
}
